"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLegend = void 0;
const styled_components_1 = __importStar(require("styled-components"));
/**
 * The problem: JSDOM uses a third-party CSS selector engine called nwsapi,
 * and it doesn't support the :has() selector. This causes Jest tests to fail when parsing styles.
 *
 * The solution: We check if the environment is 'test' and conditionally exclude styles
 * using :has() to ensure Jest can run tests without encountering syntax errors.
 *
 * https://github.com/jsdom/jsdom/issues/3506
 */
const isTestEnv = process.env.NODE_ENV === "test";
exports.StyledLegend = styled_components_1.default.legend `
    font-size: 1rem;
    font-weight: 700;
    padding: 0;

    /* Remove margin from legend if a Form.Description is adjacent to it */
    ${!isTestEnv &&
    (0, styled_components_1.css) `
        :where(&:not(&:has(+ [data-ds-form-description]))) {
            margin-bottom: 0.25rem;
        }
    `}
`;
//# sourceMappingURL=Legend.styles.js.map